import { render, staticRenderFns } from "./PicFaixasEditor.vue?vue&type=template&id=72d53b97&scoped=true&"
import script from "./PicFaixasEditor.vue?vue&type=script&lang=js&"
export * from "./PicFaixasEditor.vue?vue&type=script&lang=js&"
import style0 from "./PicFaixasEditor.vue?vue&type=style&index=0&id=72d53b97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d53b97",
  null
  
)

export default component.exports